import Image from '@/components/Image/RemoteImage';

export const ge360 = {
  bgColor: 'bg-blue-600',
  logo: (
    <svg
      className="w-32 h-32"
      width="196"
      height="196"
      viewBox="0 0 196 196"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M101.237 33.758L101.23 0L107.48 0.686005C130.91 3.26001 151.438 13.381 167.797 30.425C177.365 40.394 184.984 52.338 189.191 63.964C192.055 71.878 195.23 86.561 195.23 91.889V94.258L161.73 94.251L160.104 85.868C157.517 72.527 152.529 63.339 142.339 53.149C132.149 42.959 122.961 37.971 109.62 35.384L101.237 33.758Z"
        fill="white"
      />
      <path
        className="fill-current text-blue-200"
        d="M41.589 89.117C42.368 81.639 45.451 73.653 50.444 66.175L54.525 60.064L78.592 84.13L77.286 88.087C76.5159 90.4208 76.1152 91.9142 75.1717 92.8737C73.3818 94.6937 69.6381 94.5922 57.712 94.661L41.001 94.758L41.589 89.117Z"
        fill="white"
      />
      <path
        className="fill-current text-blue-200"
        d="M116.986 85.273L128.358 73.333C134.613 66.765 140.045 61.362 140.429 61.325C141.504 61.222 145.726 67.197 148.507 72.758C151.609 78.962 154.23 87.63 154.231 91.69V94.758L120.73 94.294L116.986 85.273Z"
        fill="white"
      />
      <path
        d="M81.252 97.72C81.214 92.488 85.21 86.116 90.137 83.552C95.715 80.649 99.768 80.651 105.27 83.561C110.208 86.172 114.23 92.545 114.23 97.758C114.23 106.511 105.105 114.884 96.562 113.969C88.076 113.06 81.311 105.88 81.252 97.72Z"
        fill="white"
      />
      <path
        className="fill-current text-blue-200"
        d="M44.309 117.738C43.216 114.817 42.0179 110.139 41.647 107.343L40.972 102.258H74.831L79.366 111.592L67.564 123.425C61.072 129.933 55.407 135.258 54.974 135.258C53.6509 135.258 46.418 123.377 44.309 117.738Z"
        fill="white"
      />
      <path
        className="fill-current text-blue-200"
        d="M117.263 109.197C117.794 108.204 118.668 106.237 119.204 104.825L120.18 102.258H137.205C154.197 102.258 154.23 102.262 154.218 104.508C154.183 111.188 147.882 126.611 142.676 132.758L140.136 135.758L128.217 123.379C118.295 113.075 116.459 110.698 117.263 109.197Z"
        fill="white"
      />
      <path
        d="M87.98 194.83C42.143 189.794 6.42096 154.657 0.715942 108.995L0 103.258H33.889L35.595 111.194C40.909 135.925 60.659 155.247 85.559 160.077L94.223 161.758L94.23 195.516L87.98 194.83Z"
        fill="white"
      />
      <path
        d="M142.838 142.215C151.069 134.017 156.809 123.746 159.534 112.337L161.703 103.258H195.418L194.741 108.508C192.694 124.385 187.637 138.266 179.316 150.851C163.036 175.47 137.241 191.452 108.48 194.74L102.23 195.454V161.604L108.825 160.388C122.37 157.893 132.564 152.446 142.838 142.215Z"
        fill="white"
      />
      <path
        className="fill-current text-blue-200"
        d="M60.73 141.336L72.714 129.297C79.306 122.676 84.916 117.258 85.181 117.258C85.446 117.258 87.591 117.994 89.947 118.894L94.23 120.53V154.258H91.624C84.587 154.258 70.291 148.724 63.23 143.268L60.73 141.336Z"
        fill="white"
      />
      <path
        className="fill-current text-blue-200"
        d="M102.23 120.264L105.48 118.842C107.268 118.061 109.187 117.384 109.746 117.34C110.304 117.295 116.122 122.633 122.675 129.203L134.588 141.147L132.159 143.199C126.536 147.949 110.843 154.213 104.48 154.246C102.234 154.258 102.23 154.224 102.23 137.261V120.264Z"
        fill="white"
      />
    </svg>
  ),
  testimonial:
    'Contar con el respaldo de las certificaciones de la Asociación Iberoamericana de Scrum, no es solo importante para GE 360, sino también para nuestros clientes, pues nos permite entregar entrenamientos de la más alta calidad y el mejor reconocimiento profesional en temas de Agilidad para nuestra región.',
  who: 'Federico Vargas',
  whoPosition: 'CEO en',
  partner: 'Grupo Empresarial 360',
  partnerLink: '/socios/grupo-empresarial-360',
};

export const fymConsulting = {
  bgColor: 'bg-blue-100',
  logo: (
    <div className="w-64">
      <Image
        alt="F & M Consulting"
        src="v1616676234/socios/f_m_mzshhk.webp"
        width="1168"
        height="212"
      />
    </div>
  ),
  testimonial:
    'Contar con el respaldo de la marca AIBES en F & M Consulting nos llena de mucha satisfacción, pues tenemos la convicción de que entregamos entrenamientos y certificaciones con el respaldo de una marca que vela por el cumplimiento de altos estándares de calidad en sus procesos de formación y entrega de contenidos.',
  who: 'Erick Masgo Dávila',
  whoPosition: 'Gerente General en',
  partner: 'F&M Consulting',
  partnerLink: '/socios/fm-consulting',
};
